module.exports = __webpack_public_path__ + "static/img/pic_32.8dc5193.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_32.png
// module id = 6ODt
// module chunks = 1